export const text = {
  CONFIRM_CANCELLATION: 'Confirm cancellation',
  CONFIRM_DELETION_MESSAGE:
    'Please confirm you wish to cancel this visit. Cancellation will not apply visit credit or cancellation fee to this patient.',
  CANCELLATION_QUESTION: 'Are you sure you wish to confirm cancellation?',
  SELECT_REASON_LABEL: 'Select reason code*',
  ADDITIONAL_NOTES_PLACEHOLDER: 'Add additional notes here.',
  GO_BACK: 'Go back',
  REASON_REQUIRED_ERROR: 'A reason code is required',
  NOTES_REQUIRED_ERROR: 'Additional notes are required',
  CHARACTER_LIMIT_ERROR: 'Character limit exceeded.',
}
